<!--
  新建 采购退货单特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
  emit:
    showProduct: 打开关联商品弹窗
 -->

<template>
  <div class="redundant">
    <!-- 关联采购单 -->
    <template v-if="item.attr === 'purchaseSheetId'">
      <associated-field
        ref="associatedField"
        :module="'purchase'"
        :item="item"
        :form="form"
        @addNew="addNew"
        @addNewPur="addNewPur"
        @emitObj="getSelectProducts"
        >
      </associated-field>
    </template>
    <!-- 退货负责人 -->
    <template v-if="item.attr === 'managerId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
    <!-- 退货产品 -->
<!--     <template v-else-if="item.attr === 'products'">
      <div class="products">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent">选择</span>
      </div>
    </template> -->
  </div>
</template>

<script>
import * as api from 'src/api'
import remoteSelect from '../remote-select'
import vManager from '../manager'
import associatedField from '../associated-field'

export default {
  props: ['item', 'form'],
  methods: {
    getSelectProducts (obj) {
      if (!(obj && obj.id)) return // 判空

      const url = '/purchase/purchaseProductList.html'
      const params = {
        purchaseId: obj.id,
        fromReturnedPurchase: 1
      }
      api.post(url, params, (data) => {
        // this.form.products = data.productList
        this.$emit('instockProList', data.productList)
        this.form.totalMoney = data.others.totalProdcutMoney
      })
    },
    emitParent () {
      this.$emit('showProduct')
    },
    addNew (obj) {
      console.log(obj)
      this.$emit('addNew', obj)
    },
    // 采购退货到采购合同
    addNewPur (obj) {
      console.log(4444444, obj)
      this.$emit('addNewPur', obj)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    }
  },
  filters: {
    productLen (arr) {
      let num = 0
      arr.forEach((item) => {
        num += item.num
      })
      num = Number(num.toFixed(5))
      return `${arr.length}种产品${num}件`
    }
  },
  components: {
    vManager,
    remoteSelect,
    associatedField
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
</style>



// WEBPACK FOOTER //
// index.vue?465884e8